export default {
    PART: ["olb"],
    SYMBOL: ["olb"],
    FOOTPRINT: ["psm", "dra"],
    HDLSYMBOL: ["zip"],
    PADSTACK: ["pad"],
    SHAPE: ["ssm", "dra"],
    FLASH: ["fsm", "dra"],
    MECHANICAL: ["bsm", "dra"],
    FORMAT: [],
    REUSEMODULE: [],
    COM: [],
    FILE: []

}



// WEBPACK FOOTER //
// ./src/constants/LibraryFilesType.js